import { FormattedMessage, FormattedNumber } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyS, HeadlineL, LabelS } from '@sorare/core/src/atoms/typography';
import { Dialog } from '@sorare/core/src/components/dialog';
import { useCurrentUserCurrencies } from '@sorare/core/src/hooks/useCurrentUserCurrencies';
import { glossary } from '@sorare/core/src/lib/glossary';

import { ESTIMATED_CASH_PRIZE_IN_USER_CURRENCY } from 'components/commonGame/UnlockPro/ChooseGameMode/LimitedPlusMode';

const DialogWrapper = styled(Vertical).attrs({ center: true })`
  padding: 0 var(--double-unit) var(--double-unit);
  & li {
    list-style-type: disc;
  }
`;

const Ul = styled.ul`
  list-style-type: disc;
  padding-left: var(--double-unit);
`;

type Props = { open: boolean; onClose: () => void };
export const InfoDialog = ({ open, onClose }: Props) => {
  const { fiatCurrency } = useCurrentUserCurrencies();
  return (
    <Dialog
      open={open}
      maxWidth="xs"
      title={
        <HeadlineL className="text-center">
          <FormattedMessage
            id="UnlockPro.InfoDialog.gettingStarted"
            defaultMessage="Getting Started"
          />
        </HeadlineL>
      }
      onClose={onClose}
      fullScreen={false}
    >
      <DialogWrapper gap={2}>
        <BodyS>
          <FormattedMessage
            id="UnlockPro.howItWorksDescription3"
            defaultMessage="Build your best fantasy football squads and play twice a week in free competitions.{br}{br}<h1>Pro Mode</h1><ul><li>Play with Limited Cards that you buy, own, and can trade or resell.</li><li>Enter prize pools with amazing VIP experiences and more than {cashPrize} in weekly cash rewards*.</li></ul>{br}<h1>Beginner Mode</h1><ul><li>Play with free Common Cards.</li><li>Great for learning the game, building your first squads, and joining competitions right away.</li></ul>"
            values={{
              h1: chunks => <BodyS bold>{chunks}</BodyS>,
              li: chunks => <li>{chunks}</li>,
              br: <br />,
              ul: chunks => <Ul>{chunks}</Ul>,
              cashPrize: (
                <FormattedNumber
                  style="currency"
                  currency={fiatCurrency}
                  value={ESTIMATED_CASH_PRIZE_IN_USER_CURRENCY}
                  currencyDisplay="narrowSymbol"
                  notation="compact"
                  maximumFractionDigits={0}
                />
              ),
            }}
          />
          <LabelS color="var(--c-nd-700)">
            <FormattedMessage
              id="UnlockPro.InfoDialog.asterix"
              defaultMessage="*This amount reflects the average cash rewards awarded in Limited In-Season competitions during weekend Game Weeks over the season. Rewards may be offered in cash, ETH or other digital assets of equivalent value. Prizes may vary and are subject to applicable law{br}*50% off, valid on purchases up to 200€, terms apply"
              values={{
                br: <br />,
              }}
            />
          </LabelS>
        </BodyS>
        <Button size="medium" color="quaternary" fullWidth onClick={onClose}>
          <FormattedMessage {...glossary.gotIt} />
        </Button>
      </DialogWrapper>
    </Dialog>
  );
};
